/**
 * Whether the document's fonts dialog is open.
 *
 * Opened from wherever a font problem shows (a page's inspector, a warning
 * about a missing character) and hosted once, by the builder.
 */

import { ref } from 'vue'

const open = ref(false)
/** The font to bring into view when it opens, if it was opened about one. */
const focusKey = ref<string | null>(null)

export function useFontsDialog() {
  return {
    open,
    focusKey,
    show(key: string | null = null): void {
      focusKey.value = key
      open.value = true
    },
    close(): void {
      open.value = false
      focusKey.value = null
    },
  }
}
